import {AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {SectionComponent} from '../../elements/section/section.component';
import {Router} from "@angular/router";
import {Icons} from "../../../model/icon";
import {TitlePageComponent} from "./items/title-page/title-page.component";
import {AboutPageComponent} from "./items/about-page/about-page.component";
import {ThanksPageComponent} from "./items/thanks-page/thanks-page.component";
import {ContactsPageComponent} from "./items/contacts-page/contacts-page.component";
import {NavigationService} from "../../../services/navigation-service";
import {ScrollToService} from "@andrei4ik/ngx-scroll-to";
import {FooterComponent} from "../../footer/footer.component";
import {HeightService} from "../../../services/height-service";
import {MainLoadingComponent} from "../../elements/main-loading/main-loading.component";

@Component({
  selector: 'app-main',
    imports: [
        SectionComponent,
        TitlePageComponent,
        AboutPageComponent,
        ThanksPageComponent,
        ContactsPageComponent,
        FooterComponent,
        MainLoadingComponent,

    ],
  templateUrl: './main.component.html',
  standalone: true,
  styleUrl: './main.component.scss',
  providers: [ScrollToService]
})
export class MainComponent implements OnInit, AfterViewInit {
    constructor(
        private navigationService: NavigationService,
        private scrollToService: ScrollToService,
        private router: Router,
        private heightService: HeightService,
    ) { }

    @ViewChild('footer') footer!: ElementRef;

    ngOnInit() {
        window.scrollTo(0, 0);
    }

    ngAfterViewInit() {
        const height = this.footer.nativeElement.offsetHeight;
        this.heightService.setActiveHeight(height);
    }

    protected readonly Icons = Icons;
}
